module.exports = __webpack_public_path__ + "img/m1.ecc74e2b8b2e872b6d89b0ccc3069789.png";